import staticConfig from 'src/config'
import SVG, { Props as SVGProps } from 'react-inlinesvg'
import { IconName } from './types/iconNames'
import clsx from 'clsx'

interface IconProps<C extends boolean = false> extends Omit<SVGProps, 'src'> {
  name: C extends true ? string : IconName
  external?: C
  cdn?: C
  tokenCdn?: C
  color?: string
  size?: string | number
}

interface GetSvgUrlOptions {
  cdn?: boolean
  tokenCdn?: boolean
}

const getSvgUrl = (name: string, { cdn, tokenCdn }: GetSvgUrlOptions) => {
  if (tokenCdn) {
    return `${staticConfig.resources.tokenIconsCdn}/svg/color/${name}.svg`
  } else if (cdn) {
    return `${staticConfig.resources.iconsCdn}/${name}.svg`
  } else {
    return `/assets/icons/${name}.svg`
  }
}

const Icon = <C extends boolean = false>({
  name,
  external,
  cdn,
  tokenCdn,
  className,
  strokeWidth,
  color,
  size,
  ...rest
}: IconProps<C>) => {
  const processSvgString = (svgString: string) => {
    let modifiedSvg = svgString

    if (strokeWidth) {
      modifiedSvg = svgString.replace(
        /stroke-width="[^"]*"/g,
        `stroke-width="${strokeWidth}"`
      )
      // modifiedSvg.replace(/stroke="[^"]*"/g, `class="${className}"`)
    }

    if (color || className) {
      modifiedSvg = modifiedSvg
        .replace(/fill=".*?"/g, `fill="currentColor"`)
        .replace(/stroke=".*?"/g, `stroke="currentColor"`)
    }

    return modifiedSvg
  }

  // Render the SVG using the src from either external link or local import
  return name ? (
    <SVG
      className={clsx(className, color && `text-${color}`)}
      src={
        external
          ? name
          : getSvgUrl(name, {
              cdn,
              tokenCdn,
            })
      }
      {...(size && { width: size, height: size })}
      {...rest}
    />
  ) : null
}

export default Icon
